
export const toGMT=(dateStr, timeStr)=> {
    if (!dateStr) return ''; // if no date, return empty
    const localDateTime = new Date(`${dateStr}T${timeStr}`); // treat as local time
    return localDateTime.toISOString().slice(0, 19).replace('T', ' '); // convert to UTC format
  }

  export const convertGMTToLocal=(gmtDateTime)=> {
    // gmtDateTime should be in format "YYYY-MM-DD HH:mm:ss"
    const localDate = new Date(gmtDateTime);
    return localDate.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // 👈 enables AM/PM
      });
   
  }
